import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/Counterparty/model'
import { AxiosErrorType, Counterparty } from '~/shared/api'
import { backFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const domain = createDomain('features.counterparty.add')

export const createFx = domain.createEffect<
  FormValues,
  Counterparty,
  AxiosErrorType
>({
  async handler(values) {
    const counterparty = new Counterparty(values)

    const result = await counterparty.save()
    return result.getModel() as Counterparty
  },
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.counterparty created' as const,
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, backFx],
})
sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
